import classNames from "classnames";
import { CellProps } from "react-table";
import ListTextCell from "src/apps/super-admin/tabs/roles/list/PermissionCell";
import Status from "src/components/status/Status";
import TextCell from "src/components/tables/cells/TextCell";
import { PRODUCT_STATUS, PRODUCT_STATUS_CELL } from "src/utils/constants";
import { InventoryType } from "./inventory-types";

const useInventoryTableColumns = ({
  onDelete,
  onStatusClick,
}: {
  onDelete: (id: number) => void;
  onStatusClick: (id: number) => void;
}) => {
  return [
    {
      Header: "Store name",
      accessor: "storeName",
      className: "min-w-[180px]",
      Cell: TextCell,
    },
    {
      Header: "Product name",
      accessor: "products",
      className: "min-w-[150px]",
      Cell: ListTextCell,
    },
    {
      Header: "Quantity",
      accessor: "totalQuantity",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Price",
      accessor: "totalPrice",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Status",
      accessor: "status",
      className: "min-w-[150px]",
      Cell: ({ row: { original } }: CellProps<InventoryType>) => {
        const status = PRODUCT_STATUS_CELL[original.status as PRODUCT_STATUS];
        return (
          <span
            onClick={() =>
              original.status === PRODUCT_STATUS.AVAILABLE
                ? onStatusClick(original.id)
                : null
            }
            className={classNames({
              "cursor-pointer": original.status === PRODUCT_STATUS.AVAILABLE,
            })}
          >
            <Status {...status} />
          </span>
        );
      },
    },
    // {
    //   Header: "Actions",
    //   accessor: "id",
    //   className: "min-w-[200px]",
    //   Cell: ({ value }: CellProps<InventoryType>) => (
    //     <ActionsCell value={value} onDelete={() => onDelete(value)} />
    //   ),
    // },
  ];
};

export default useInventoryTableColumns;
